import { COUNTRY_CALLING_CODES, inferCountryFromPhone } from './countryFromPhone.js';

// Area codes are grouped as authored from the source reference (by province, in the
// order given), not pre-sorted — inferStateFromPhone sorts by code length at match time.
// Where a country has multiple provinces sharing an area-code line (e.g. Colombia,
// Ecuador, Bolivia group several departments/provinces under one code), only the
// first-listed province is kept, since a single area code can't disambiguate further
// from phone digits alone.
const AREA_CODES_BY_COUNTRY = {
  "Argentina": [
    { code: "11", state: "CABA/GBA" },
    { code: "221", state: "Buenos Aires" },
    { code: "223", state: "Buenos Aires" },
    { code: "291", state: "Buenos Aires" },
    { code: "249", state: "Buenos Aires" },
    { code: "236", state: "Buenos Aires" },
    { code: "220", state: "Buenos Aires" },
    { code: "230", state: "Buenos Aires" },
    { code: "2284", state: "Buenos Aires" },
    { code: "2281", state: "Buenos Aires" },
    { code: "2477", state: "Buenos Aires" },
    { code: "2983", state: "Buenos Aires" },
    { code: "383", state: "Catamarca" },
    { code: "362", state: "Chaco" },
    { code: "364", state: "Chaco" },
    { code: "280", state: "Chubut" },
    { code: "297", state: "Chubut" },
    { code: "2945", state: "Chubut" },
    { code: "351", state: "Córdoba" },
    { code: "353", state: "Córdoba" },
    { code: "358", state: "Córdoba" },
    { code: "3541", state: "Córdoba" },
    { code: "3564", state: "Córdoba" },
    { code: "379", state: "Corrientes" },
    { code: "3777", state: "Corrientes" },
    { code: "3773", state: "Corrientes" },
    { code: "343", state: "Entre Ríos" },
    { code: "345", state: "Entre Ríos" },
    { code: "3442", state: "Entre Ríos" },
    { code: "3446", state: "Entre Ríos" },
    { code: "370", state: "Formosa" },
    { code: "388", state: "Jujuy" },
    { code: "2954", state: "La Pampa" },
    { code: "2302", state: "La Pampa" },
    { code: "380", state: "La Rioja" },
    { code: "261", state: "Mendoza" },
    { code: "260", state: "Mendoza" },
    { code: "2622", state: "Mendoza" },
    { code: "376", state: "Misiones" },
    { code: "3757", state: "Misiones" },
    { code: "3751", state: "Misiones" },
    { code: "299", state: "Neuquén" },
    { code: "294", state: "Neuquén" },
    { code: "2942", state: "Neuquén" },
    // 294 and 299 are reused under Río Negro (Bariloche/Cipolletti) in the source data —
    // kept only under Neuquén (listed first) since a code can't map to two provinces here.
    { code: "298", state: "Río Negro" },
    { code: "2920", state: "Río Negro" },
    { code: "387", state: "Salta" },
    { code: "264", state: "San Juan" },
    { code: "266", state: "San Luis" },
    { code: "2657", state: "San Luis" },
    { code: "2966", state: "Santa Cruz" },
    { code: "2902", state: "Santa Cruz" },
    // 297 is reused under Santa Cruz (Caleta Olivia) in the source data — kept only
    // under Chubut (listed first).
    { code: "341", state: "Santa Fe" },
    { code: "342", state: "Santa Fe" },
    { code: "3492", state: "Santa Fe" },
    { code: "3482", state: "Santa Fe" },
    { code: "3462", state: "Santa Fe" },
    { code: "385", state: "Santiago del Estero" },
    { code: "2901", state: "Tierra del Fuego" },
    { code: "2964", state: "Tierra del Fuego" },
    { code: "381", state: "Tucumán" },
  ],
  "Brasil": [
    { code: "68", state: "Acre" },
    { code: "82", state: "Alagoas" },
    { code: "96", state: "Amapá" },
    { code: "92", state: "Amazonas" },
    { code: "97", state: "Amazonas" },
    { code: "71", state: "Bahia" },
    { code: "73", state: "Bahia" },
    { code: "74", state: "Bahia" },
    { code: "75", state: "Bahia" },
    { code: "77", state: "Bahia" },
    { code: "85", state: "Ceará" },
    { code: "88", state: "Ceará" },
    { code: "61", state: "Distrito Federal" },
    { code: "27", state: "Espírito Santo" },
    { code: "28", state: "Espírito Santo" },
    { code: "62", state: "Goiás" },
    { code: "64", state: "Goiás" },
    { code: "98", state: "Maranhão" },
    { code: "99", state: "Maranhão" },
    { code: "65", state: "Mato Grosso" },
    { code: "66", state: "Mato Grosso" },
    { code: "67", state: "Mato Grosso do Sul" },
    { code: "31", state: "Minas Gerais" },
    { code: "32", state: "Minas Gerais" },
    { code: "33", state: "Minas Gerais" },
    { code: "34", state: "Minas Gerais" },
    { code: "35", state: "Minas Gerais" },
    { code: "37", state: "Minas Gerais" },
    { code: "38", state: "Minas Gerais" },
    { code: "91", state: "Pará" },
    { code: "93", state: "Pará" },
    { code: "94", state: "Pará" },
    { code: "83", state: "Paraíba" },
    { code: "41", state: "Paraná" },
    { code: "42", state: "Paraná" },
    { code: "43", state: "Paraná" },
    { code: "44", state: "Paraná" },
    { code: "45", state: "Paraná" },
    { code: "46", state: "Paraná" },
    { code: "81", state: "Pernambuco" },
    { code: "87", state: "Pernambuco" },
    { code: "86", state: "Piauí" },
    { code: "89", state: "Piauí" },
    { code: "21", state: "Rio de Janeiro" },
    { code: "22", state: "Rio de Janeiro" },
    { code: "24", state: "Rio de Janeiro" },
    { code: "84", state: "Rio Grande do Norte" },
    { code: "51", state: "Rio Grande do Sul" },
    { code: "53", state: "Rio Grande do Sul" },
    { code: "54", state: "Rio Grande do Sul" },
    { code: "55", state: "Rio Grande do Sul" },
    { code: "69", state: "Rondônia" },
    { code: "95", state: "Roraima" },
    { code: "47", state: "Santa Catarina" },
    { code: "48", state: "Santa Catarina" },
    { code: "49", state: "Santa Catarina" },
    { code: "11", state: "São Paulo" },
    { code: "12", state: "São Paulo" },
    { code: "13", state: "São Paulo" },
    { code: "14", state: "São Paulo" },
    { code: "15", state: "São Paulo" },
    { code: "16", state: "São Paulo" },
    { code: "17", state: "São Paulo" },
    { code: "18", state: "São Paulo" },
    { code: "19", state: "São Paulo" },
    { code: "79", state: "Sergipe" },
    { code: "63", state: "Tocantins" },
  ],
  "México": [
    { code: "449", state: "Aguascalientes" },
    { code: "664", state: "Baja California" },
    { code: "686", state: "Baja California" },
    { code: "646", state: "Baja California" },
    { code: "665", state: "Baja California" },
    { code: "612", state: "Baja California Sur" },
    { code: "624", state: "Baja California Sur" },
    { code: "613", state: "Baja California Sur" },
    { code: "981", state: "Campeche" },
    { code: "938", state: "Campeche" },
    { code: "961", state: "Chiapas" },
    { code: "967", state: "Chiapas" },
    { code: "962", state: "Chiapas" },
    { code: "614", state: "Chihuahua" },
    { code: "656", state: "Chihuahua" },
    { code: "625", state: "Chihuahua" },
    { code: "639", state: "Chihuahua" },
    { code: "55", state: "Ciudad de México" },
    { code: "844", state: "Coahuila" },
    { code: "871", state: "Coahuila" },
    { code: "866", state: "Coahuila" },
    { code: "878", state: "Coahuila" },
    { code: "312", state: "Colima" },
    { code: "314", state: "Colima" },
    { code: "618", state: "Durango" },
    // 871 is reused under Durango (Gómez Palacio) in the source data — kept only under
    // Coahuila (listed first).
    { code: "722", state: "Estado de México" },
    // 55 ("zona conurbada") is reused under Estado de México in the source data — kept
    // only under Ciudad de México (listed first).
    { code: "477", state: "Guanajuato" },
    { code: "473", state: "Guanajuato" },
    { code: "462", state: "Guanajuato" },
    { code: "461", state: "Guanajuato" },
    { code: "744", state: "Guerrero" },
    { code: "747", state: "Guerrero" },
    { code: "755", state: "Guerrero" },
    { code: "733", state: "Guerrero" },
    { code: "771", state: "Hidalgo" },
    { code: "775", state: "Hidalgo" },
    { code: "33", state: "Jalisco" },
    { code: "322", state: "Jalisco" },
    { code: "378", state: "Jalisco" },
    { code: "443", state: "Michoacán" },
    { code: "452", state: "Michoacán" },
    { code: "753", state: "Michoacán" },
    { code: "351", state: "Michoacán" },
    { code: "777", state: "Morelos" },
    { code: "735", state: "Morelos" },
    { code: "311", state: "Nayarit" },
    { code: "329", state: "Nayarit" },
    { code: "81", state: "Nuevo León" },
    { code: "951", state: "Oaxaca" },
    { code: "971", state: "Oaxaca" },
    { code: "958", state: "Oaxaca" },
    { code: "222", state: "Puebla" },
    { code: "238", state: "Puebla" },
    { code: "442", state: "Querétaro" },
    { code: "427", state: "Querétaro" },
    { code: "998", state: "Quintana Roo" },
    { code: "984", state: "Quintana Roo" },
    { code: "983", state: "Quintana Roo" },
    { code: "987", state: "Quintana Roo" },
    { code: "444", state: "San Luis Potosí" },
    { code: "667", state: "Sinaloa" },
    { code: "669", state: "Sinaloa" },
    { code: "668", state: "Sinaloa" },
    { code: "662", state: "Sonora" },
    { code: "644", state: "Sonora" },
    { code: "631", state: "Sonora" },
    { code: "642", state: "Sonora" },
    { code: "993", state: "Tabasco" },
    { code: "833", state: "Tamaulipas" },
    { code: "899", state: "Tamaulipas" },
    { code: "868", state: "Tamaulipas" },
    { code: "867", state: "Tamaulipas" },
    { code: "834", state: "Tamaulipas" },
    { code: "246", state: "Tlaxcala" },
    { code: "229", state: "Veracruz" },
    { code: "228", state: "Veracruz" },
    { code: "921", state: "Veracruz" },
    { code: "271", state: "Veracruz" },
    { code: "782", state: "Veracruz" },
    { code: "999", state: "Yucatán" },
    { code: "492", state: "Zacatecas" },
    { code: "493", state: "Zacatecas" },
  ],
  // Colombia's codes cover multiple departments each — only the first-listed
  // department per code is kept (a single area code can't disambiguate further).
  "Colombia": [
    { code: "1", state: "Bogotá D.C." },
    { code: "2", state: "Valle del Cauca" },
    { code: "4", state: "Antioquia" },
    { code: "5", state: "Atlántico" },
    { code: "6", state: "Caldas" },
    { code: "7", state: "Santander" },
    { code: "8", state: "Boyacá" },
  ],
  "Chile": [
    { code: "2", state: "Región Metropolitana" },
    { code: "58", state: "Arica y Parinacota" },
    { code: "57", state: "Tarapacá" },
    { code: "55", state: "Antofagasta" },
    { code: "52", state: "Atacama" },
    { code: "51", state: "Coquimbo" },
    { code: "53", state: "Coquimbo" },
    { code: "32", state: "Valparaíso" },
    { code: "33", state: "Valparaíso" },
    { code: "34", state: "Valparaíso" },
    { code: "35", state: "Valparaíso" },
    { code: "72", state: "O'Higgins" },
    { code: "71", state: "Maule" },
    { code: "73", state: "Maule" },
    { code: "75", state: "Maule" },
    { code: "42", state: "Ñuble" },
    { code: "41", state: "Biobío" },
    { code: "43", state: "Biobío" },
    { code: "45", state: "La Araucanía" },
    { code: "63", state: "Los Ríos" },
    { code: "65", state: "Los Lagos" },
    { code: "64", state: "Los Lagos" },
    { code: "67", state: "Aysén" },
    { code: "61", state: "Magallanes" },
  ],
  "Perú": [
    { code: "1", state: "Lima y Callao" },
    { code: "41", state: "Amazonas" },
    { code: "43", state: "Áncash" },
    { code: "83", state: "Apurímac" },
    { code: "54", state: "Arequipa" },
    { code: "66", state: "Ayacucho" },
    { code: "76", state: "Cajamarca" },
    { code: "84", state: "Cusco" },
    { code: "67", state: "Huancavelica" },
    { code: "62", state: "Huánuco" },
    { code: "56", state: "Ica" },
    { code: "64", state: "Junín" },
    { code: "44", state: "La Libertad" },
    { code: "74", state: "Lambayeque" },
    { code: "65", state: "Loreto" },
    { code: "82", state: "Madre de Dios" },
    { code: "53", state: "Moquegua" },
    { code: "63", state: "Pasco" },
    { code: "73", state: "Piura" },
    { code: "51", state: "Puno" },
    { code: "42", state: "San Martín" },
    { code: "52", state: "Tacna" },
    { code: "72", state: "Tumbes" },
    { code: "61", state: "Ucayali" },
  ],
  // Ecuador's codes cover multiple provinces each — only the first-listed province
  // per code is kept.
  "Ecuador": [
    { code: "2", state: "Pichincha" },
    { code: "3", state: "Cotopaxi" },
    { code: "4", state: "Guayas" },
    { code: "5", state: "Manabí" },
    { code: "6", state: "Imbabura" },
    { code: "7", state: "Azuay" },
  ],
  // Bolivia's codes cover multiple departments each — only the first-listed
  // department per code is kept.
  "Bolivia": [
    { code: "2", state: "La Paz" },
    { code: "3", state: "Santa Cruz" },
    { code: "4", state: "Cochabamba" },
  ],
  "Uruguay": [
    { code: "2", state: "Montevideo" },
    { code: "42", state: "Maldonado" },
    { code: "43", state: "Canelones" },
    { code: "434", state: "San José" },
    { code: "435", state: "Florida" },
    { code: "436", state: "Durazno" },
    // 436 is reused under Flores in the source data — kept only under Durazno
    // (listed first).
    { code: "444", state: "Lavalleja" },
    { code: "445", state: "Treinta y Tres" },
    { code: "447", state: "Rocha" },
    { code: "452", state: "Colonia" },
    { code: "453", state: "Soriano" },
    { code: "456", state: "Río Negro" },
    { code: "462", state: "Rivera" },
    { code: "463", state: "Tacuarembó" },
    { code: "464", state: "Cerro Largo" },
    { code: "472", state: "Paysandú" },
    { code: "473", state: "Salto" },
    { code: "477", state: "Artigas" },
  ],
  // Combined lines like "Asunción y Central" are assigned to the first-listed
  // department, same simplification as Colombia/Ecuador/Bolivia.
  "Paraguay": [
    { code: "21", state: "Asunción" },
    { code: "228", state: "Asunción" },
    { code: "294", state: "Asunción" },
    { code: "61", state: "Alto Paraná" },
    { code: "631", state: "Alto Paraná" },
    { code: "71", state: "Itapúa" },
    { code: "521", state: "Caaguazú" },
    { code: "522", state: "Caaguazú" },
    { code: "541", state: "Guairá" },
    { code: "331", state: "Concepción" },
    { code: "336", state: "Amambay" },
    { code: "511", state: "Cordillera" },
    { code: "531", state: "Paraguarí" },
    { code: "81", state: "Misiones" },
    { code: "86", state: "Ñeembucú" },
    { code: "46", state: "Canindeyú" },
    { code: "226", state: "Presidente Hayes" },
    { code: "491", state: "Boquerón" },
  ],
  // "Distrito Capital, La Guaira y Miranda" combined line assigned to the
  // first-listed state, same simplification as above.
  "Venezuela": [
    { code: "212", state: "Distrito Capital" },
    { code: "234", state: "Distrito Capital" },
    { code: "248", state: "Amazonas" },
    { code: "247", state: "Apure" },
    { code: "273", state: "Barinas" },
    { code: "281", state: "Anzoátegui" },
    { code: "282", state: "Anzoátegui" },
    { code: "243", state: "Aragua" },
    { code: "244", state: "Aragua" },
    { code: "286", state: "Bolívar" },
    { code: "285", state: "Bolívar" },
    { code: "241", state: "Carabobo" },
    { code: "242", state: "Carabobo" },
    { code: "245", state: "Carabobo" },
    { code: "258", state: "Cojedes" },
    { code: "287", state: "Delta Amacuro" },
    { code: "268", state: "Falcón" },
    { code: "269", state: "Falcón" },
    { code: "246", state: "Guárico" },
    { code: "235", state: "Guárico" },
    { code: "251", state: "Lara" },
    { code: "252", state: "Lara" },
    { code: "274", state: "Mérida" },
    { code: "291", state: "Monagas" },
    { code: "295", state: "Nueva Esparta" },
    { code: "255", state: "Portuguesa" },
    { code: "257", state: "Portuguesa" },
    { code: "293", state: "Sucre" },
    { code: "294", state: "Sucre" },
    { code: "276", state: "Táchira" },
    { code: "271", state: "Trujillo" },
    { code: "254", state: "Yaracuy" },
    { code: "261", state: "Zulia" },
    { code: "264", state: "Zulia" },
  ],
  // "Artemisa y Mayabeque" combined line assigned to the first-listed province,
  // same simplification as above.
  "Cuba": [
    { code: "7", state: "La Habana" },
    { code: "47", state: "Artemisa" },
    { code: "48", state: "Pinar del Río" },
    { code: "45", state: "Matanzas" },
    { code: "42", state: "Villa Clara" },
    { code: "43", state: "Cienfuegos" },
    { code: "41", state: "Sancti Spíritus" },
    { code: "33", state: "Ciego de Ávila" },
    { code: "32", state: "Camagüey" },
    { code: "31", state: "Las Tunas" },
    { code: "24", state: "Holguín" },
    { code: "23", state: "Granma" },
    { code: "22", state: "Santiago de Cuba" },
    { code: "21", state: "Guantánamo" },
    { code: "46", state: "Isla de la Juventud" },
  ],
};

export const inferStateFromPhone = (phone, country) => {
  if (!phone || !country) return undefined;
  const areaCodes = AREA_CODES_BY_COUNTRY[country];
  if (!areaCodes) return undefined;

  const digits = phone.replace(/\D/g, "");
  if (!digits) return undefined;

  const callingCode = COUNTRY_CALLING_CODES.find((c) => c.country === country);
  if (!callingCode || !digits.startsWith(callingCode.code)) return undefined;

  let rest = digits.slice(callingCode.code.length);

  // Argentina mobiles carry a "9" marker between the country code and the area
  // code (e.g. +54 9 11 ...) — strip it before matching the area code.
  if (country === "Argentina" && rest.startsWith("9")) {
    rest = rest.slice(1);
  }

  const sortedAreaCodes = [...areaCodes].sort((a, b) => b.code.length - a.code.length);
  const match = sortedAreaCodes.find(({ code }) => rest.startsWith(code));
  return match?.state;
};

export const getCustomerState = (customer) => {
  if (!customer) return undefined;
  const dbState = customer.state?.trim();
  if (dbState) return dbState;

  const country = customer.country?.trim() || inferCountryFromPhone(customer.mainUserPhone);
  return inferStateFromPhone(customer.mainUserPhone, country);
};
